import{css as o}from"styled-components";const t=o`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;export{t as CommonFontStyle};
//# sourceMappingURL=common.js.map
